const autoNgTemplateLoaderTemplate1 = require('./score-table.template.html');

'use strict';

import { NAVIGATION_ICON } from '../../modules/shared/constants/system/navigationIcons';
import { SOLUTION_TYPE } from '../../modules/shared/constants/user-info/solutionType';

(function () {
    angular
        .module('app.scoreTable', [])
        .config(scoreTableConfig);

    scoreTableConfig.$inject = ['$routeProvider'];

    function scoreTableConfig($routeProvider) {
        $routeProvider
            .when('/score-table', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate1,
                controller: 'ScoreTableController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: SOLUTION_TYPE.NUTRITION,
                    breadcrumbs: [
                        { label: 'Compliance Scores', icon: NAVIGATION_ICON.THUMB_UP }
                    ]
                }
            })
    }
})();
